import React, { useContext } from "react";
import { useState, useEffect } from "react";
import './ProjectClient.css'
import { Breadcrumb, Col, Form, Row } from 'react-bootstrap'
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faBorderAll, faEllipsisVertical, faPenToSquare, faTrashCan, faPlus } from '@fortawesome/free-solid-svg-icons';
import ProjectClientModal from './ProjectClientModal/ProjectClientAddModal';
import ProjectClientEditModal from './ProjectClientModal/ProjectClientEditModal';
import ProjectDeleteClientModal from './ProjectClientModal/ProjectDeleteClientModal';
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import ProjectGridView from './ProjectGridView';
import ProjectListView from './ProjectListView';
import ProjectListTable from './ProjectListTable';
import { Context } from "../../../utils/context";

const options = [
    { value: 'National', label: 'National' },
    { value: 'Indian', label: 'Indian' },
    { value: 'Local', label: 'Local' },
];

const ProjectClient = () => {
    const [selectedOption, setSelectedOption] = useState(null);
    const [dropdownVisible, setDropdownVisible] = useState(null);
    const [modalShow, setModalShow] = useState(false);

    const { getData, Select2Data, isAllow } = useContext(Context);
    const [data, setData] = useState();

    const [projects, setProjects] = useState([]);
    const [project, setProject] = useState();
    const [search, setSearchName] = useState("");
    const [client_id, setClientId] = useState("");

    const getDataAll = async () => {
        const response = await getData(
            `/projectmanagement/client?term=${search}&project=${project?.value || ""}&client_id=${client_id}`
        );
        await setData(response);
    };
    useEffect(() => {
        getDataAll();
    }, [project, search, client_id]);

    const GetAllProjects = async () => {
        const res = await getData("/project_management/allproject");
        if (res?.success) {
            setProjects(await Select2Data(res?.data, "project_id"))
        }
    };

    useEffect(() => {
        GetAllProjects();
        getDataAll();
    }, []);


    return (
        <section className='project-add'>
            <div className='d-flex justify-content-between'>
                <div className='main-title'>
                    <h2>Client</h2>
                    <Breadcrumb>
                        <Breadcrumb.Item href="/">Dashboard</Breadcrumb.Item>
                        <Breadcrumb.Item active>Client</Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                {isAllow.includes(178) ? (
                    <div>
                        <button className='create-project-btn mt-2' onClick={() => setModalShow(true)} ><FontAwesomeIcon icon={faPlus} className='me-1 mt-1' /> Add Client</button>
                        <ProjectClientModal
                            show={modalShow}
                            onHide={() => setModalShow(false)}
                            getDataAll={getDataAll}
                        />
                    </div>
                ) : (
                    <></>
                )}
            </div>
            <Row>
                <Col lg={3} md={6} sm={12} xs={12} >
                    <Form>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <input
                                type="text"
                                className="form-control"
                                id=""
                                placeholder="Client Name"
                                value={search}
                                onChange={(e) => {
                                    setSearchName(e.target.value);
                                }}
                            />
                        </Form.Group>
                    </Form>
                </Col>
                <Col lg={3} md={6} sm={12} xs={12}>
                    <Form>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput2">
                            <input
                                type="text"
                                className="form-control"
                                id=""
                                placeholder="Client ID"
                                value={client_id}
                                onChange={(e) => {
                                    setClientId(e.target.value);
                                }}
                            />
                        </Form.Group>
                    </Form>
                </Col>
                <Col lg={3} md={6} sm={12} xs={12}>
                    <Select
                        isSearchable
                        options={projects}
                        value={project}
                        placeholder="Project"
                        onChange={(e) => {
                            setProject(e);
                        }}
                    />
                </Col>
                <Col lg={3} md={6} sm={12} xs={12} className='mt-3 mt-md-0'>
                    <button
                        className='search-button mt-3 mt-md-0'
                        onClick={async () => {
                            setSearchName("");
                            setProject("");
                            setClientId("")
                        }}
                    >
                        Clear
                    </button>
                </Col>
            </Row>
            {/* Gridview */}
            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                <Nav variant="pills" className="flex-row justify-content-end mb-2 ">
                    <Nav.Item>
                        <Nav.Link eventKey="first"><FontAwesomeIcon icon={faBars} /></Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="second"><FontAwesomeIcon icon={faBorderAll} /></Nav.Link>
                    </Nav.Item>
                </Nav>
                <Tab.Content>
                    <Tab.Pane eventKey="first">
                        <ProjectListView
                            data={data}
                            getDataAll={getDataAll} />
                        {/* <ProjectListTable
                            data={data}
                            getDataAll={getDataAll}
                        /> */}
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                        <ProjectGridView
                            data={data}
                            getDataAll={getDataAll}
                        />
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        </section>
    )
}

export default ProjectClient;
